export default __webpack_public_path__ + "static/media/charting-promo-background.fbfec067988d20c222ffeac16e3c3b70.svg";